import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
import { systemAPI } from '../../../../apis';
import { AddWardPop, EditWardPop } from '../Pops';
import Results from '../Results';
import { WardTable } from '../Table';
import { WardToolBar } from '../ToolBar';
import { updateRoleMapAction } from '../../../../redux/actions/roleMap';
import { updateUserRoleAction } from '../../../../redux/actions/userRole';
import { rewriteSettingRequestParams } from '../../../../utils/check';
import { SETTING_EDIT_TABLE } from '../../../../comm/constant';

const useStyles = makeStyles((theme) => ({
  results: {
    padding: '1.875rem',
  },
}));

function Ward({ loginInfo, roleMap, updateRoleMap, updateUserRole }) {
  const classes = useStyles();
  const PAGESIZE = 20;

  const [WardList, setWardList] = useState([]);
  const [count, setCount] = useState(null);

  const [keyword, setKeyword] = useState(null);

  const getSysWardList = async (pageSize, pageNo) => {
    const { result } =
      (await systemAPI.getSysWardList(
        rewriteSettingRequestParams({
          pageSize: pageSize,
          ward: keyword,
          pageNo: pageNo,
          corpId: loginInfo.corpID,
          hospId: loginInfo.hospitalId,
          userId: loginInfo.userId,
        })
      )) ?? {};
    setCount(result?.count ?? 0);
    const newWardList = [...WardList.slice(0, (pageNo - 1) * pageSize), ...(result?.data ?? [])];
    setWardList(newWardList);
    return result?.data;
  };

  const nextPageCall = async (pageSize, pageNo) => {
    try {
      if (count === null || count !== WardList.length) {
        await getSysWardList(pageSize, pageNo);
      }
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  useEffect(() => {
    (async () => {
      if (keyword !== null) {
        try {
          await getSysWardList(PAGESIZE, 1);
          tableRef.current.scrollTo(0, 0);
        } catch {}
      }
    })();
  }, [keyword]);

  // WardToolBar
  const [isAddPop, setIsAddPop] = useState(false);
  const closeAddPop = () => {
    setIsAddPop(false);
  };
  const addClick = () => {
    setIsAddPop(true);
  };

  // WardTable
  const [isEditPop, setEditPop] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const editClick = (item, index) => {
    setEditPop(true);
    setEditIndex(index);
  };
  const closeEditPop = () => {
    setEditPop(false);
  };
  const editPopConfirmClick = async (data) => {
    try {
      await systemAPI.updateWard(data);
      await updateMenu(data);
      const pageNo = Math.ceil((editIndex + 1) / PAGESIZE);
      const temp = await getSysWardList(PAGESIZE, pageNo);
      closeEditPop();
      const index = temp?.findIndex((item) => item.wardId === data.wardId);
      setHideIndex(index > -1 ? (pageNo - 1) * PAGESIZE + index : index);
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  const tableRef = useRef(null);
  const addPopConfirmClick = async (data) => {
    try {
      const { result } = await systemAPI.createSysWard(data);
      const temp = await getSysWardList(PAGESIZE, 1);
      closeAddPop();
      tableRef.current.scrollTo(0, 0);
      setHideIndex(temp?.findIndex((item) => item.wardId === result.id));
    } catch (error) {
      console.log('-----Ward error-----', error);
    }
  };

  const [hideIndex, setHideIndex] = useState(null);

  const updateMenu = async ({ wardId }) => {
    if (loginInfo.wardId === wardId) {
      const { result } = await systemAPI.getSysUserRole({ corpId: loginInfo.corpID });
      if (Array.isArray(result)) {
        sessionStorage.setItem(SETTING_EDIT_TABLE, true);
        updateUserRole(result);

        console.log('=============user role 获取成功============');
      }
      return new Error('UserRole不是数组');
    }
  };

  return (
    <>
      <WardToolBar
        addClick={addClick}
        searchClick={(val) => {
          setKeyword(val);
        }}
        onChange={_.debounce((val) => {
          setKeyword(val);
        }, 500)}
        roleMap={roleMap}
      />
      <Results length={count} className={classes.results} />
      <WardTable
        editClick={editClick}
        allData={WardList}
        nextPageCall={nextPageCall}
        pageSize={PAGESIZE}
        hideIndex={hideIndex}
        setHideIndex={setHideIndex}
        ref={tableRef}
      />
      {isAddPop ? <AddWardPop open={isAddPop} closePop={closeAddPop} confirmClick={addPopConfirmClick} /> : ''}
      {isEditPop ? (
        <EditWardPop
          open={isEditPop}
          closePop={closeEditPop}
          allData={WardList[editIndex]}
          confirmClick={editPopConfirmClick}
        />
      ) : (
        ''
      )}
    </>
  );
}

export default connect(
  (state) => ({
    roleMap: state.roleMap,
    loginInfo: state.loginInfo,
    rouList: state.rouList,
  }),
  {
    updateRoleMap: updateRoleMapAction,
    updateUserRole: updateUserRoleAction,
  }
)(Ward);
